/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rir: NonNullable<unknown> }} Quick_Workout_RirInputs */

const en_us2_quick_workout_rir = /** @type {(inputs: Quick_Workout_RirInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Leave ${i?.rir} reps in reserve`)
};

const pt_br2_quick_workout_rir = /** @type {(inputs: Quick_Workout_RirInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deixe ${i?.rir} repetições sobrando`)
};

const es_419_quick_workout_rir = /** @type {(inputs: Quick_Workout_RirInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deja ${i?.rir} repeticiones en reserva`)
};

const pt_pt2_quick_workout_rir = /** @type {(inputs: Quick_Workout_RirInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deixa ${i?.rir} repetições de reserva`)
};

const fr_fr2_quick_workout_rir = /** @type {(inputs: Quick_Workout_RirInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Garde ${i?.rir} répétitions en réserve`)
};

const de_de2_quick_workout_rir = /** @type {(inputs: Quick_Workout_RirInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lass ${i?.rir} Wdh. im Tank`)
};

const it_it2_quick_workout_rir = /** @type {(inputs: Quick_Workout_RirInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tieni ${i?.rir} ripetizioni di riserva`)
};

/**
* | output |
* | --- |
* | "Leave {rir} reps in reserve" |
*
* @param {Quick_Workout_RirInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_rir = /** @type {((inputs: Quick_Workout_RirInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_RirInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_rir(inputs)
	if (locale === "es-419") return es_419_quick_workout_rir(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_rir(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_rir(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_rir(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_rir(inputs)
	return en_us2_quick_workout_rir(inputs)
});
export { quick_workout_rir as "quick-workout.rir" }